import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withTheme } from 'styled-components'
import { Modal } from 'antd'

// Components
import { Image } from '../../../Reusable/Image'
import PageHeader from '../../../Reusable/PageHeader'
import ConnectionModal from '../../../Reusable/ConnectionModal'
import SettingsModal from '../SettingsModal'
import BoldBanner from '../../../Reusable/BoldBanner'
import ViewBill from '../ViewBill'
import InboxTable from './InboxTable'
import { FlexColumn, Flex } from '../../../Reusable/Container'
import { ErrorAlert } from '../../../Reusable/Alert'
import { TextButton } from '../../../Reusable/Button'
import AlertModal from '../../../Reusable/AlertModal'

// Actions and Utils
import { addDataToStore, CODAT_DATA, SAVE_DATA } from '../../../../Actions/actions'
import environment from '../../../../environment'
import { apiPOSTReq } from '../../../../Utils/api'
import { showCodatConnectionBanner } from '../../../../Utils/util'

// Images
import ModalClose from '../../../../Images/modal-close.png'
import Lightning from '../../../../Images/lightning-dark.svg'
import SettingsIcon from '../../../../Images/integration/setting.png'
import Info from '../../../../Images/info.png'

import SetupMailbox from './SetupMailbox'
import { Text } from '../../../Reusable/Text'

class Index extends Component {

    state = {
        selectedTab: this.props.selectedTab || "New",
        modalWidth: 700,
        showViewBillModal: false,
        categories: [],
        coaPagination: {
            current: 1,
            pageSize: 200
        },
        vendor: {},
        showConnectAS: false,
        showSettingsModal: false,
    }

    componentDidMount() {
        const urlStr = this.props.location.search.replace('?', '')
        const queryParams = new URLSearchParams(urlStr)
        const statusCode = queryParams.get('statuscode')
        const errorMessage = queryParams.get('errormessage')
        const statusText = queryParams.get('statustext')
        // http://{website}/{path}/?statuscode={statusCode}&errormessage={errorMessage}&statusText={statusText}
        // Check if redirected from codat
        if (statusCode) {
            console.log("BillPayments Inbox statusCode", statusCode)
            if (statusCode == 200) {
                this.fetchCOA({ coaPagination: this.state.coaPagination })
                this.getConnections(true)
            } else {
                ErrorAlert({ description: errorMessage || statusText || "Sorry we had trouble processing your request. Please try connecting again" })
            }
        } else {
            console.log("BillPayments Inbox NO statusCode")
        }

        this.getConnections()
        this.fetchMailboxEmail()
        this.fetchCOA({ coaPagination: this.state.coaPagination })
    }

    fetchMailboxEmail = () => {
        apiPOSTReq(`${environment.payBaseUrl}/payables/bills/getBillSetup`, { "BankProvider": environment.bankProvider.crb }, {}, (err, resp) => {
            try {
                const data = resp || {}
                console.log("/payables/bills/getBillSetup", err, data)
                if (data.result) {
                    const billInboxSetups = data.billInboxSetups || []
                    this.setState({ billInboxSetups: billInboxSetups, showMailboxSetup: !(billInboxSetups.length > 0) })
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR /payables/bills/getBillSetup", error, err, resp)
                ErrorAlert({ description: error.message })
            }
        })
    }

    fetchCOA = (options) => {
        const { coaPagination } = options
        const headers = {
            AionCurrentBiz: this.props.aionStore.BusinessUniqueKey,
            AionAuth: this.props.aionStore.UAM.encryptedAuthHeader
        }
        const body = {
            "BusinessId": this.props.aionStore.BusinessUniqueKey,
            "size": coaPagination.pageSize,
            "page": 0,
            "ActiveRecords": true,
            "sortFieldName": "Code",
            "sortDirection": "ASC",
        }
        this.setState({ newProductLoading: true })
        apiPOSTReq(`${environment.bbBaseUrl}/bk/getCategories`, headers, body, (err, resp) => {
            try {
                const data = resp
                console.log("/bk/getCategories", data)
                if (data.result) {
                    // this.props.dispatch(addDataToStore(BOOKKEEPING_SAVE_DATA, { COA: (data.systemCOAList || []).concat(data.customCOAList) }))
                    this.setState({
                        coaPagination: {
                            ...coaPagination,
                            total: data.count
                        },
                        categories: (data.systemCOAList || []).concat(data.customCOAList),
                    })
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR getActiveCustomers", error.stack, resp)
                ErrorAlert({ description: error.message })
            }
        })
    }

    handleBillDetail = (inboxItem) => {
        this.props.history.push({
            pathname: '/payables/inbox/detail',
            state: { inboxItem: inboxItem }
        })
    }

    getConnections = (showSuccess) => {
        apiPOSTReq(`${environment.integrationBaseUrl}/integration/codat/getConnections`, {}, {}, (err, resp) => {
            try {
                const data = resp || {};
                if (data.result) {
                    var connections = data.connections || []
                    console.log("BillPayments Inbox /integration/codat/getConnections data", data)
                    this.props.dispatch(addDataToStore(CODAT_DATA, { connections: connections, connection: connections.length > 0 && connections[0], company: data.company }))
                    if (showSuccess) {
                        if(connections.length > 0) this.updateConnection(connections[0])
                        this.setState({ showSettingsModal: true })
                    }
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("BillPayments Inbox getConnections error", { description: error.message })
            }
        })
    }

    updateConnection = (connection) => {
        var body = {
            companyId: connection.companyId,
            connectionId: connection.connectionId
        }
        console.log("BillPayments Inbox updateConnection body", body)
        apiPOSTReq(`${environment.integrationBaseUrl}/integration/codat/updateConnection`, {}, body, (err, resp) => {
            try {
                const data = resp || {};
                if (data.result) {
                    console.log("BillPayments Inbox updateConnection data", data)
                    this.props.history.replace('/payables/inbox')
                    this.props.dispatch(addDataToStore(CODAT_DATA, { connection: data.connection }))
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                ErrorAlert({ description: error.message })
            }
        })
    }

    onChangeTab = (selectedTab) => {
        this.setState({ selectedTab: selectedTab })
    }

    render() {
        const { theme, aionStore } = this.props
        const { 
            selectedTab, 
            billInboxSetups, 
            showMailboxSetup, 
            modalWidth, 
            showConnectAS, 
            showDismissConnectWarning,
            showViewBillModal, 
            billToView, 
            categories, 
            vendor, 
            showSettingsModal, 
            showSyncSetupComplete, 
            showDismissSetupWarning 
        } = this.state
        
        const lastBillInboxSetup = (billInboxSetups || []).length > 0 ? billInboxSetups[0].emailAddress : null
        const showConnectionBanner = showCodatConnectionBanner(aionStore)
        
        let inboxDescription = <Flex start><span>Bills sent to your AP email at <a href={`mailto:${lastBillInboxSetup}`}>{lastBillInboxSetup}</a> will show up right here.</span></Flex>
        
        return (
            <>
                <FlexColumn start grow>
                    <PageHeader
                        titleText="Bill Payments"
                        subtitle="Bill Payments"
                    />

                    {
                        showConnectionBanner &&
                        <BoldBanner
                            icon={<Image src={Lightning} />}
                            style={{ marginTop: "0", marginBottom: 24, width: "100%" }}
                            message="Sync your bills, vendors and more to your accounting system. Skip all the manual work"
                            cta={<TextButton underline color={theme.colors.primary2} text={'Get started now'} onClick={() => {
                                this.setState({ showConnectAS: true })
                            }} />}
                            onClose={() => {
                                this.setState({ showDismissConnectWarning: true })
                                this.props.dispatch(addDataToStore(SAVE_DATA, { connectASBannerDismissed: true }))
                            }}
                        />
                    }

                    <InboxTable
                        selectedTab={selectedTab}
                        onTabChange={this.onChangeTab}
                        history={this.props.history}
                        customDescription={inboxDescription}
                        onBillSelect={this.handleBillDetail}
                        // showTabs={true}
                    />
                </FlexColumn>
                
                <Modal
                    visible={!(showConnectAS && showSettingsModal) && showMailboxSetup}
                    footer={null}
                    closable={true}
                    maskClosable={false}
                    width={modalWidth}
                    destroyOnClose={true}
                    onCancel={() => this.setState({ showMailboxSetup: false })}
                    closeIcon={<Image src={ModalClose} />}
                >
                    <SetupMailbox
                        setupComplete={
                            (billInboxSetups) => {
                                this.setState({ billInboxSetups: billInboxSetups, showMailboxSetup: false })
                                this.fetchMailboxEmail()
                            }
                        }
                    />
                </Modal>
                
                <Modal
                    visible={showViewBillModal}
                    footer={null}
                    closable={true}
                    maskClosable={true}
                    width={(billToView || {}).previewDocumentUrls && billToView.previewDocumentUrls.length > 0 ? 1150 : 700}
                    style={{ top: 20 }}
                    destroyOnClose={true}
                    onCancel={() => this.setState({ showViewBillModal: false, billToView: null })}
                    closeIcon={<Image src={ModalClose} />}
                >
                    <ViewBill
                        bill={billToView}
                        vendor={vendor}
                        categories={categories}
                    />
                </Modal>
                
                <Modal
                    visible={showConnectAS}
                    footer={null}
                    closable={true}
                    maskClosable={true}
                    width={697}
                    destroyOnClose={true}
                    onCancel={() => this.setState({ showConnectAS: false })}
                    closeIcon={<Image src={ModalClose} />}
                >
                    <ConnectionModal onCancel={() => this.setState({ showConnectAS: false })} />
                </Modal>
                
                <Modal
                    visible={showSettingsModal}
                    footer={null}
                    closable={true}
                    maskClosable={true}
                    width={697}
                    destroyOnClose={true}
                    onCancel={() => this.setState({ showSettingsModal: false, showDismissSetupWarning: true })}
                    closeIcon={<Image src={ModalClose} />}
                >
                    <SettingsModal
                        learn
                        onCancel={() => this.setState({ showSettingsModal: false, showSyncSetupComplete: true })}
                    />
                </Modal>

                <AlertModal
                    success
                    visible={showSyncSetupComplete}
                    title='Sync setup complete'
                    description={`You're all set! The connection was successful and your sync is in progress.`}
                    buttonTitle='OKAY'
                    onConfirm={() => this.setState({ showSyncSetupComplete: false })}
                />

                <AlertModal
                    imgSrc={Info}
                    visible={showDismissConnectWarning}
                    title='Accessing your Connections'
                    description={<Text>You can go to Settings {'>'} Accounting Systems anytime to connect Aion to your accounting system.</Text>}
                    buttonTitle='OKAY'
                    onConfirm={() => this.setState({ showDismissConnectWarning: false })}
                />

                <AlertModal
                    imgSrc={Info}
                    visible={showDismissSetupWarning}
                    title='Bill settings incomplete'
                    description={<Text>You can go to Settings {'>'} Accounting Systems {'>'} Settings <Image width='14px' height='14px' src={SettingsIcon} /> anytime to complete your setup.</Text>}
                    buttonTitle='OKAY'
                    onConfirm={() => this.setState({ showDismissSetupWarning: false })}
                />
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        bkStore: state.bookkeepingAppReducer,
        aionStore: state.aionAppReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTheme(Index))